module.exports = __webpack_public_path__ + "static/img/good1.5fcbb4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/good1.jpg
// module id = /fz8
// module chunks = 30